var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Directive, Input, TemplateRef, Output, EventEmitter, ContentChild } from '@angular/core';
import { NglTab } from './tab';
/*
 * <ngl-tab [heading="..."]>
 *    <ng-template ngl-tab-heading>...</ng-template>
 *    <ng-template ngl-tab-content>
 *       Content goes here...
 *    </ng-template>
 * </ngl-tab>
 */
var NglTabHeading = (function () {
    function NglTabHeading(templateRef) {
        this.templateRef = templateRef;
    }
    NglTabHeading.decorators = [
        { type: Directive, args: [{ selector: '[ngl-tab-heading]' },] },
    ];
    /** @nocollapse */
    NglTabHeading.ctorParameters = function () { return [
        { type: TemplateRef, },
    ]; };
    return NglTabHeading;
}());
export { NglTabHeading };
var NglTabContent = (function () {
    function NglTabContent(templateRef) {
        this.templateRef = templateRef;
    }
    NglTabContent.decorators = [
        { type: Directive, args: [{ selector: '[ngl-tab-content]' },] },
    ];
    /** @nocollapse */
    NglTabContent.ctorParameters = function () { return [
        { type: TemplateRef, },
    ]; };
    return NglTabContent;
}());
export { NglTabContent };
var NglTabVerbose = (function (_super) {
    __extends(NglTabVerbose, _super);
    function NglTabVerbose() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onActivate = new EventEmitter();
        _this.onDeactivate = new EventEmitter();
        return _this;
    }
    NglTabVerbose.prototype.ngAfterContentInit = function () {
        if (this.headingTemplate) {
            this.heading = this.headingTemplate.templateRef;
        }
        this.templateRef = this.contentTemplate.templateRef;
    };
    NglTabVerbose.decorators = [
        { type: Directive, args: [{
                    selector: 'ngl-tab',
                    providers: [{ provide: NglTab, useExisting: NglTabVerbose }],
                },] },
    ];
    /** @nocollapse */
    NglTabVerbose.ctorParameters = function () { return []; };
    NglTabVerbose.propDecorators = {
        'id': [{ type: Input, args: ['nglTabId',] },],
        'heading': [{ type: Input },],
        'onActivate': [{ type: Output },],
        'onDeactivate': [{ type: Output },],
        'contentTemplate': [{ type: ContentChild, args: [NglTabContent,] },],
        'headingTemplate': [{ type: ContentChild, args: [NglTabHeading,] },],
    };
    return NglTabVerbose;
}(NglTab));
export { NglTabVerbose };
//# sourceMappingURL=tab-verbose.js.map